import { Component } from "react";
import { draftSystems } from "../../utils/constants";
import systemStyles from "./systemInstallation.module.css";
class SystemInstallation extends Component {
    title = 'Draft System Installations'
    installationList() {
        return (
            <div className={`light-bg d-flex justify-content-center py-5 text-dark`}>
                <div className={`d-flex ${systemStyles.mobile_wrapper}`}>
                    <div className={`container ${systemStyles.padding_mobile}`}>
                        <h1 class="display-2 fw-bolder text-capitalize">{this.title}</h1>
                        <h3 class="mt-5 fs-4 text-uppercase">We install all types of draft systems</h3>
                        <ul class="list-group list-group-flush align-items-start fs-5 mt-5">
                            {
                                draftSystems.map((system) => (
                                    <li className={`list-group-item transparent-bg invert-every-other-item-list ${systemStyles.item_list}`} key={system.id}>
                                        <div className={`row py-5 ${systemStyles.item_wrapper}`}>
                                            <div class="col-sm-5 col-md-6 md-img">
                                                <img className={`w-inherit ${systemStyles.item_img}`} src={system.imgSrc}></img>
                                            </div>
                                            <div class="col-sm-5 col-md-6 d-flex px-5">
                                                <div class="m-auto">
                                                    <h4 class="mt-5 fs-4 text-uppercase text-center">{system.title}</h4>
                                                    <p class="text-start mt-5">{system.description}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
    render() {
        return (
            <>
                <section class="mt-navbar">
                    {this.installationList()}
                </section>
            </>
        );
    }
}

export default SystemInstallation;